import html2pdf from 'html2pdf.js';
import moment from 'moment';
import { useEffect } from 'react';

interface Props {
    data: any;
    setShowAllowanceReport: any;
    setAllowanceFormId: any;
}

export const TrainingAllowancePDF = (props: Props) => {
    const { data, setShowAllowanceReport, setAllowanceFormId } = props;

    const image1 = new Image();
    image1.src = '/images/notice_header.png';
    const image2 = new Image();
    image2.src = '/images/notice_footer.png';

    let html =
        `
                <style>   
                    
                        body {
                            margin: 0;
                            color: #000 !important;
                            background-color: #ffff;
                            font-family: "Times New Roman", Times, serif !important;
                            font-size: 10pt !important;                     
                        }
                        .AllowanceReport {
                            padding: 0.5in;
                            color: #000000;
                        }
                            .instruction-text{
                                font-size: 12px;
                                }
                
                </style>  
                        
               <div class='border border-dark border-2 p-1 mt-1'>
                    <!--1st page starting-->

                    <div class='d-flex justify-content-center mb-0'>
                        <span class='text-decoration h5 text-primary'>Bill of Non-Governmental Trainees Allowances (Honorium)</span> &nbsp; &nbsp;
                        <span>SL No. ${data?.approval_serial ?? ''}</span>
                    </div>

                    <div class='row'>
                        <div class='col-12'>
                            <span class='fw-semibold'>Name of the Trainee (In capital letters as per NID card) : </span>
                            ${data?.registration?.personal_info?.full_name ? 
                                `<span>${data?.registration?.personal_info?.full_name?.toUpperCase()}</span>`
                                : 
                                `<span>
                                    ..............................................................................................................................................................................
                                </span>`
                            }
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6'>
                            <span class='fw-semibold'>Registration No. BCPS : </span>                                                                       
                            ${data?.registration?.bcps_registration_no ? 
                                `<span>${data?.registration?.bcps_registration_no}</span>`
                                : 
                                `<span>.............................................</span>`
                            } 
                        </div>
                        <div class='col-6'>
                            <span class='fw-semibold'>Subject : </span>                                                                       
                            ${data?.registration?.subject ? 
                                `<span>${data?.registration?.subject?.subject_name}</span>`
                                : 
                                `<span>.............................................</span>`
                            } 
                        </div>
                        
                    </div>
                    <div class='row'>
                        <div class='col-4'>
                            <span class='fw-semibold'>BMDC Registration No : </span>
                            ${data?.registration?.bmdc_registration_no ? 
                                `<span>${data?.registration?.bmdc_registration_no}</span>`
                                : 
                                `<span></span>`
                            }                                                        
                        </div>
                        <div class='col-4'>
                            <span class='fw-semibold'>Date of Birth : </span>                            
                            ${data?.registration?.personal_info?.date_of_birth ? 
                                `<span>${moment(data?.registration?.personal_info?.date_of_birth).format('DD-MMM-YYYY')}</span>`
                                : 
                                `<span></span>`
                            }
                        </div>
                        <div class='col-4'>
                            <span class='fw-semibold'>Gender : </span>                            
                            ${data?.registration?.personal_info?.gender ? 
                                `<span>${data?.registration?.personal_info?.gender}</span>`
                                : 
                                `<span></span>`
                            }
                        </div>
                    </div>

                    <div class='row'>
                        <div class='col-3'>
                            <span class='fw-semibold'>Passing Session : </span>                            
                            ${data?.registration?.fcps_part_one_passing_session ?
                                `<span>${data?.registration?.fcps_part_one_passing_session}</span>`
                                : 
                                `<span>............</span>`
                            } 
                        </div>  
                        <div class='col-3'>
                            <span class='fw-semibold'>Passing Year : </span>                            
                            ${data?.registration?.fcps_part_one_passing_year ?
                                `<span>${data?.registration?.fcps_part_one_passing_year}</span>`
                                : 
                                `<span>............</span>`
                            } 
                        </div>  
                        <div class='col-6'>
                            <span class='fw-semibold'>NID / Smart Card No : </span>                            
                            ${data?.registration?.personal_info?.national_id ?
                                `<span>${data?.registration?.personal_info?.national_id}</span>`
                                : 
                                `<span>............</span>`
                            } 
                        </div>                     
                    </div>

                    <div class='row'>
                        <div class='col-6'>
                            <span class='fw-semibold'>Mobile Number (Personal) : </span>                                                                                                                            
                            ${data?.registration?.personal_info?.mobile ? 
                                `<span>${data?.registration?.personal_info?.mobile}</span>`
                                : 
                                `<<span>...............................................</span>`
                            } 
                        </div>

                        <div class='col-6'>
                            <span class='fw-semibold'>Applying Honorarium Slot : </span>                            
                            ${data?.no_of_allowance_received ? 
                                `<span>${data?.no_of_allowance_received}</span>`
                                : 
                                `<span>...............................................</span>`
                            } 
                        </div>
                    </div>

                    <div class='row'>
                        <div class='col-6'>
                            <span class='fw-semibold'>Institute Name : </span>                            
                            ${data?.log_entry_session?.supervisor_info?.current_employment_info?.institute_name ? 
                                `<span>${data?.log_entry_session?.supervisor_info?.current_employment_info?.institute_name}</span>`
                                : 
                                `<span>..............................................</span>`
                            } 
                        </div>
                        <div class='col-6'>
                            <span class='fw-semibold'>Department : </span>                            
                            ${data?.log_entry_session?.supervisor_info?.current_employment_info?.department_name ? 
                                `<span>${data?.log_entry_session?.supervisor_info?.current_employment_info?.department_name}</span>`
                                : 
                                `<span>................................................</span>`
                            } 
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6'>
                            <span class='fw-semibold'>Current Training Session : </span>                            
                            ${data?.log_entry_session?.session_start_date && data?.log_entry_session?.session_end_date ? 
                                `<span>${moment(data?.log_entry_session?.session_start_date).format('DD-MMM-YYYY')} to  ${moment(data?.log_entry_session?.session_end_date).format('DD-MMM-YYYY')}</span>`
                                : 
                                `<span>..................................................</span>`
                            } 
                        </div>
                        
                        <div class='col-6'>
                            <span class='fw-semibold'>Current Training Slot : </span>                                                                                                                            
                            ${data?.slot_no ? 
                                `<span>${data?.slot_no}</span>`
                                : 
                                `<span>..................................................</span>`
                            } 
                        </div>
                    </div>
                    

                    <div class='row'>
                        <div class='col-6'>
                            <span class='fw-semibold'>Name of the Bank : </span>                            
                            ${data?.registration?.bank_info?.bank_name ? 
                                `<span>${data?.registration?.bank_info?.bank_name}</span>`
                                : 
                                `<span>................................................</span>`
                            } 
                        </div>
                        <div class='col-6'>
                            <span class='fw-semibold'>Branch Name : </span>                            
                            ${data?.registration?.bank_info?.branch_name ? 
                                `<span>${data?.registration?.bank_info?.branch_name}</span>`
                                : 
                                `<span>...................................................</span>`
                            } 
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-6'>
                            <span class='fw-semibold'>Bank Account Number : </span>                            
                            ${data?.registration?.bank_info?.account_no ? 
                                `<span>${data?.registration?.bank_info?.account_no}</span>`
                                : 
                                `<span>...................................................</span>`
                            }
                        </div>
                        <div class='col-6'>
                            <span class='fw-semibold'>Routing Number : </span>                            
                            ${data?.registration?.bank_info?.routing_no ? 
                                `<span>${data?.registration?.bank_info?.routing_no}</span>`
                                : 
                                `<span>...................................................</span>`
                            }
                        </div>
                    </div>
                    <div class='row mt-1'>
                        <div class='col-12 text-center instruction-text text-white bg-dark'>
                            NB: 1. Provisional Training Certificate, 2. Copy of FCPS Part-1 Congratulations Letter 3. Copy of FCPS Midterm Congratulations 
                            Letter/ Failed Result Document 4. Copy of any page of the Personal bank MICR cheque / Bank Statement with printed Name &
                            Routing Number (if applicable) and 5. Copy of NID/ Smart Card of the trainee must be herewith according to notice
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-12'>
                            I have received  35,000x6=2,10,000/- (In words: Two lakh and ten thousand) as training allowance (Honorium) for last 6 month period <b> ${moment(data?.log_entry_session?.session_start_date).format('MMMM')} to  ${moment(data?.log_entry_session?.session_end_date).format('MMMM')} ${moment(data?.log_entry_session?.session_end_date).format('YYYY')} </b>.
                        </div>
                    </div>
                    <div class='row'>
                        <div class='fw-bold text-decoration-underline text-center'>Declaration:</div>
                        <div class='col-12'>
                            <p>
                                I am Dr. ${data?.registration?.personal_info?.full_name} declaring that all the information given by me are true.I have completed my last six (6) months training in the ${data?.registration?.subject_name} department of 
                                ${data?.log_entry_session?.supervisor_info?.current_employment_info?.institute_name} hospital/institute. Apart from this training, I was not involved in any other 
                                job/duty/practice and also have not received salary/allowances from any other source. 
                                If the above information is proved false (even in partly), BCPS can take any legal action and I will be liable to refund the money.
                            </p>
                        </div>
                    </div>
                    <div class='row justify-content-end mb-5 mt-1'>
                        <div class='col-6 border-top border-dark text-center'>
                            <b>Trainee's full name, Signature and Date</b>
                        </div>
                    </div>
                    <div class='row justify-content-between mb-1'>
                        <div class='col-4 border-top border-dark text-center'>
                            <b>Signature and seal of Supervisor</b>
                        </div>
                        <div class='col-6 border-top border-dark text-center'>
                            <b>Signature and seal of Director (Hospital/Superintendent)</b>
                        </div>
                    </div>
                    <div class='row mb-1'>
                        <div class='col-12 border-dark border-bottom'>
                            
                        </div>
                    </div>
                    <div class='d-flex justify-content-center'>
                        <span class='text-decoration-underline text-primary'>For Use of RTM Department</span>
                    </div>
                    <div class='row mb-5'>
                        <div class='col-12'>
                            <span>A provisional training certificate and relevant documents duly submitted by the trainee to RTM department and training allowances may be disbursed to the trainees Bank Account on the basis of submitted documents therefor.</span>
                        </div>
                    </div>
                    <div class='row justify-content-between'>
                        <div class='col-3 border-top border-dark text-center'>
                            <span><strong>Checked by</strong></span>
                        </div>
                        <div class='col-3 border-top border-dark text-center'>
                            <span><strong>Additional Director (RTM)</strong></span>
                        </div>
                        <div class='col-3 border-top border-dark text-center'>
                            <span><strong>Honorary Director (RTM)</strong></span>
                        </div>
                    </div>
                    <div class='row mb-1'>
                        <div class='col-12 border-dark border-bottom'>
                            
                        </div>
                    </div>
                    <div class='d-flex justify-content-center mb-1'>
                        <span class='text-decoration-underline text-primary'>For Use of Accounts and Administration Department</span>
                    </div>
                    <div class='row mb-2'>
                        <div class='col-12'>
                            <p>
                                Bills submitted for the remuneration of non-government trainees are payable under the Government Allowances 
                                Assistance Sector (Code No. 3631102). Accordingly, based on the report from the training institute and RTMD 
                                of BCPS, a total of six (6) months of allowances, amounting to Tk. 35,000 per month, total Tk. 2,10,000/- (In 
                                words: Two lakh and ten thousand), has been sanctioned and disbursed for the period from <b> ${moment(data?.log_entry_session?.session_start_date).format('MMMM')} to  ${moment(data?.log_entry_session?.session_end_date).format('MMMM')} ${moment(data?.log_entry_session?.session_end_date).format('YYYY')} </b>.
                            </p>
                        </div>
                    </div>
                    <div class='row justify-content-between mb-5'>
                        <div class='col-3 text-center'>
                            <span>Accounts Officer</span>
                        </div>
                        
                        <div class='col-3 text-center'>
                            <span>Deputy Director (Admin)</span>
                        </div>                       
                        <div class='col-3 text-center'>
                            <span>Additional Director (Admin)</span>
                        </div>
                        <div class='col-3 text-center'>
                            <span>Additional Director (Finance)</span>
                        </div>
                    </div>
                    <div class='row justify-content-between'>
                        <div class='col-3 text-center'>
                            <span>Director (Admin)</span>
                        </div>
                        <div class='col-2 text-center'>
                            <span>Secretary</span>
                        </div>
                        <div class='col-2 text-center'>
                            <span>Treasurer</span>
                        </div>
                    </div>

                    <!--

                    2nd page starting

                    <div class='d-flex mb-3'>
                        <strong><span class='text-decoration-underline'>অবৈতনিক প্রশিক্ষণার্থীদের ভাতাদি বাবদ সহায়তা (পারিতোষিক) প্রদান বিল ফরমটি জমাদানের নিয়মাবলীঃ</span></strong>
                    </div>
                    <div class='row mb-3'>
                        <div class='col-12'>
                            <ul class='list-unstyled'>
                                <li class='mb-2'>
                                    ১. প্রশিক্ষণ সময় বলতে বর্তমান ৬ মাস প্রশিক্ষন সময়কাল লিখতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ২. প্রশিক্ষণার্থীকে অবশ্যই বিসিপিএস কর্তৃক স্বীকৃত প্রতিষ্ঠানে প্রশিক্ষণ গ্রহণ করতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ৩. আবেদনকারীর রেজিষ্ট্রেশন নম্বরে এফসিপিএস পার্ট-১ পাশের পর রেজিষ্ট্রিকৃত রেজিষ্ট্রেশন নম্বর (যা আইটি বিভাগ সরবরাহ করেছে) লিখতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ৪. পারিতোষিক বিলে অবশ্যই ১০ টাকা মূল্যের রেভিনিউ ষ্ট্যাম্প নির্দিষ্ট স্থানে সংযুক্ত করতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ৫. এফসিপিএস ১ম পর্ব পাসকৃত অবৈতনিক প্রশিক্ষণার্থীদের পারিতোষিক বিল জমাদানের ক্ষেত্রে আবেদনকারীকে পূর্বে আবেদনকৃত ফরমে উল্লেখিত <strong>সচল ব্যাংক হিসাব নম্বর</strong> লিখতে হবে। অন্যথায় টাকা পেতে বিলম্ব হলে/ না পেলে বিসিপিএস কর্তৃপক্ষ দায়ী থাকবে না।
                                </li>
                                <li class='mb-2'>
                                    ৬. পারিতোষিক বিল বিসিপিএস এর আরটিএম বিভাগে জমাদানের সময় আবেদনকারীদের পারিতোষিক বিলে অবৈতনিক প্রশিক্ষণার্থীদের রেজিষ্ট্রেশন খাতায় উল্লেখিত ক্রমিক নম্বর বিল ফরমের উপরে ডান পাশে লিখে জমা দিতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ৭. ইতঃপূর্বে যাঁরা অবৈতনিক প্রশিক্ষণার্থী হিসেবে পারিতোষিকের জন্য আবেদন করেছেন <strong>কেবলমাত্র তাঁরাই</strong> বিল ফরম জমা দিবেন এবং পূর্বের কোন তথ্য পরিবর্তন হলে আরটিএম বিভাগের অনারারি পরিচালক বরাবর লিখিত আবেদনের মাধ্যমে অবহিত করতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ৮. এফসিপিএস ১ম পর্ব পাসকৃত অবৈতনিক প্রশিক্ষণার্থীদের পারিতোষিক বিল জমাদানের ক্ষেত্রে যে সকল আবেদনকারী এফসিপিএস কোর্স ব্যতীত রেসিডেন্সি কোর্স/ ডিপ্লোমা কোর্স/ পেইড ট্রেনিং/ চাকুরিতে আছেন তাঁদেরকে পারিতোষিক বিল জমা না দেয়ার জন্য অনুরোধ করা হলো। তাঁরা এই অনারিয়ামের আওতাভুক্ত নন।
                                </li>
                                <li class='mb-2'>
                                    ৯. নির্ধারিত সময়ের মধ্যে অবশ্যই বিল ফরম দাখিল করতে হবে।
                                </li>
                                <li>
                                    ১০. অসম্পূর্ন ও ত্রুটিপূর্ণ বিল ফরম গ্রহণযোগ্য হবে না।
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class='d-flex mb-3'>
                        <strong><span>বিঃদ্রঃ</span></strong>
                    </div>
                    <div class='row mb-3'>
                        <div class='col-12'>
                            <span>এফসিপিএস ১ম পর্ব পাস করা অবৈতনিক প্রশিক্ষণার্থীগণ একবার ভাতা প্রাপ্ত হওয়ার পর বিরতি দিয়ে পুনরায় প্রশিক্ষণ শুরু করলে নিম্নলিখিত শর্ত সাপেক্ষে প্রশিক্ষণ ভাতা প্রাপ্য হবেনঃ</span>
                        </div>
                    </div>
                    <div class='row mb-1 ms-3'>
                        <div class='col-12'>
                            <ul class='list-unstyled'>
                                <li class='mb-2'>
                                    ১) প্রশিক্ষণ থেকে বিরতি নেয়ার পূর্বে প্রশিক্ষণার্থীকে অবশ্যই কলেজের আরটিএম বিভাগ ও সংশ্লিষ্ট প্রতিষ্ঠানের কর্তৃপক্ষের নিকট থেকে অনুমতি নিতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ২) বিরতি নেয়ার পর পুনরায় প্রশিক্ষণে যোগদান করলে প্রশিক্ষণার্থীকে কলেজের আরটিএম বিভাগে লিখিত আবেদন সহ সংশ্লিষ্ট প্রতিষ্ঠানের যোগদানপত্র এবং সংশ্লিষ্ট যাবতীয় কাগজপত্রাদি কলেজের আরটিএম বিভাগে জমা দিতে হবে।
                                </li>
                                <li class='mb-2'>
                                    ৩) ০৫ বছর মেয়াদী ফেলোশীপ প্রোগ্রামের আওতায় প্রশিক্ষণ গ্রহণকালে যুক্তিসঙ্গত কারণে একজন প্রশিক্ষণার্থী সর্বোচ্চ ০৩ বার প্রশিক্ষণে বিরতি নিতে পারবেন।
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                -->
                
        `;

    useEffect(() => {
        setShowAllowanceReport(false);
        setAllowanceFormId('');
    }, []);

    const options = {
        margin: [20, 5, 5, 5],
        image: { type: 'png', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
    };

    html2pdf()
        .from(html)
        .set(options)
        .toPdf()
        .get('pdf')
        .then(function (pdf: any) {
            var totalPages = pdf.internal.getNumberOfPages();

            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.setTextColor(150);
                pdf.addImage(image1, "PNG", 0, 0, pdf.internal.pageSize.getWidth(), 20);
                pdf.addImage(image2, "PNG", 0, pdf.internal.pageSize.getHeight() - 10, pdf.internal.pageSize.getWidth(), 10);
            }

            window.open(pdf.output('bloburl'), '_blank');
        });

    return null;
};
